import { render, staticRenderFns } from "./StatementLogs.vue?vue&type=template&id=1cf66813&scoped=true&"
import script from "./StatementLogs.vue?vue&type=script&lang=js&"
export * from "./StatementLogs.vue?vue&type=script&lang=js&"
import style0 from "./StatementLogs.vue?vue&type=style&index=0&id=1cf66813&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf66813",
  null
  
)

export default component.exports